import { useState } from "react";

export default function BigToggle({ size = 60, onChange ,value=false}) {
  const [enabled, setEnabled] = useState(value);

  const width = size * 2;
  const knob = size - 8;
  const padding = 4;

  function handleToggle() {
    const newValue = !enabled;
    setEnabled(newValue);

    // 🔥 send value to parent
    if (onChange) {
      onChange(newValue);
    }
  }

  return (
    <button
      onClick={handleToggle}
      style={{
        width,
        height: size,
        padding,
        borderRadius: size,
        backgroundColor: enabled ? "#22c55e" : "#d1d5db",
        display: "flex",
        alignItems: "center",
        justifyContent: enabled ? "flex-end" : "flex-start",
        position: "relative",
        transition: "all 0.3s ease",
        fontWeight: "700",
        fontSize: size / 3.5,
        color: "white",
      }}
    >
      {/* Label */}
      <span
        className={`${enabled ? "text-slate-700" : "text-slate-900"}`}
        style={{
          position: "absolute",
          left: enabled ? 12 : "auto",
          right: enabled ? "auto" : 12,
          opacity: enabled ? 1 : 0.7,
          transition: "all 0.25s ease",
          pointerEvents: "none",
        }}
      >
        {enabled ? "True" : "False"}
      </span>

      {/* Knob */}
      <span
        style={{
          width: knob,
          height: knob,
          borderRadius: "50%",
          backgroundColor: "white",
          transition: "all 0.3s ease",
        }}
      />
    </button>
  );
}